import { OETrans } from '@components/translation/OETrans';
import React from 'react';
import { Spinner } from 'react-bootstrap';

interface LoadingProps {
	fixedHeight?: string;
}

const Loading: React.FC<LoadingProps> = ({ fixedHeight = '100%' }) => {
	return (
		<div className="d-flex justify-content-center align-items-center" style={{ height: fixedHeight }}>
			<Spinner animation="border" role="status">
				<span style={{ visibility: 'hidden' }}>
					<OETrans code="common.loading" fallback={'Caricamento'} />
					...
				</span>
			</Spinner>
		</div>
	);
};

export default Loading;
